import { Component, Input } from '@angular/core';
import { AlertComponent } from 'app/shared/ui/alerts/alert.component';
import { BlockLoadingComponent } from 'app/shared/ui/loading/block-loading.component';


@Component({
    selector: 'loading-account',
    imports: [
        BlockLoadingComponent,
        AlertComponent,
    ],
    template: `
        @if (loading) {
            <div class="container pt-5">
                <div class="pt-5 text-center">
                    <ui-block-loading>Loading...</ui-block-loading>
                    <p class="pt-2">
                        Hi there! Sit tight as we secure your account.<br>
                        You will be re-directed to <strong>AUTOPROP</strong> shortly.
                    </p>
                </div>
            </div>
        }
        @else {
            <ui-alert [type]="success ? 'success' : 'danger'"><div class="text-center">{{ message }}</div></ui-alert>
        }
    `,
})
export class LoadingAccountComponent {

    @Input() loading: boolean;

    @Input() success: boolean;

    @Input() message?: string;
}
